<div class="container">

    <h1>KVKK Aydınlatma Metni</h1>
    <h3>6698 sayılı Kişisel Verilerin Korunması Kanunu</h3>
    <p>TV264 olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında veri sorumlusu sıfatıyla
        işlenen kişisel verileriniz hakkında sizleri bilgilendirmek isteriz. Bu metin, internet sitemizi ziyaret
        eden, yayınlarımızı takip eden ve bizimle iletişime geçen gerçek kişilere yöneliktir.</p>

    <h2>1. Veri sorumlusu</h2>
    <p>Kişisel verileriniz, veri sorumlusu sıfatıyla TV264 (Adapazarı / Sakarya) tarafından işlenmektedir.
        İletişim bilgilerine sitemizin <a routerLink="/iletisim">İletişim</a> sayfasından ulaşabilirsiniz.</p>

    <h2>2. İşlenen kişisel veriler</h2>
    <p>Faaliyetlerimiz kapsamında, ilgili kişiyle olan ilişkinin türüne göre aşağıdaki veriler işlenebilir:</p>
    <ul>
        <li>Kimlik bilgileri (ad, soyad)</li>
        <li>İletişim bilgileri (telefon, e-posta, adres)</li>
        <li>Mesaj ve talep içeriği</li>
        <li>İşlem güvenliği verileri (IP adresi, tarayıcı ve cihaz bilgisi, çerez kayıtları)</li>
        <li>Görsel ve işitsel kayıtlar (yayın, etkinlik veya açık rızaya dayalı içerikler)</li>
    </ul>

    <h2>3. Kişisel verilerin işlenme amaçları</h2>
    <p>Kişisel verileriniz aşağıdaki amaçlarla işlenir:</p>
    <ul>
        <li>Yayın, haber, program ve web hizmetlerinin sunulması</li>
        <li>İzleyici, izleyici destek hattı ve iletişim taleplerinin karşılanması</li>
        <li>Site güvenliğinin sağlanması, kötüye kullanımın önlenmesi ve teknik altyapının işletilmesi</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
        <li>İstatistik, analiz ve hizmet kalitesinin artırılması</li>
    </ul>

    <h2>4. Hukuki sebepler</h2>
    <p>Kişisel verileriniz, KVKK’nın 5. ve 6. maddelerinde belirtilen hukuki sebeplere dayanılarak işlenir.
        Bunlar arasında; açık rızanız, bir sözleşmenin kurulması veya ifası, hukuki yükümlülüğün yerine
        getirilmesi, bir hakkın tesisi, kullanılması veya korunması ve meşru menfaatlerimiz yer alır.</p>

    <h2>5. Kişisel verilerin aktarılması</h2>
    <p>Kişisel verileriniz, yukarıdaki amaçlarla sınırlı olarak; yasal mercilere, hizmet aldığımız tedarikçilere
        (barındırma, e-posta, analitik, yayın altyapısı vb.) ve kanunen yetkili kamu kurumlarına aktarılabilir.
        Aktarım, KVKK ve ilgili mevzuata uygun şekilde yapılır.</p>

    <h2>6. Toplama yöntemi</h2>
    <p>Verileriniz; web sitemiz, iletişim formu, telefon ve e-posta kanalları, çerezler ve otomatik kayıt
        sistemleri ile elektronik ortamda toplanır.</p>

    <h2>7. Çerezler</h2>
    <p>Sitemizde oturum çerezleri ve benzeri teknolojiler kullanılabilir. Çerezler, siteyi düzgün çalıştırmak,
        ziyaret istatistiklerini görmek ve kullanıcı deneyimini iyileştirmek için kullanılır. Tarayıcı
        ayarlarınızdan çerezleri reddedebilirsiniz; bu durumda bazı işlevler kısıtlı çalışabilir. Ayrıntılar
        için <a routerLink="/gizlilik-ilkesi">Gizlilik İlkesi</a> sayfasına bakabilirsiniz.</p>

    <h2>8. İlgili kişinin hakları</h2>
    <p>KVKK’nın 11. maddesi uyarınca; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna
        ilişkin bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, yurt
        içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme, eksik veya yanlış işlenmişse düzeltilmesini
        isteme, KVKK’nın 7. maddesi çerçevesinde silinmesini veya yok edilmesini isteme, bu işlemlerin aktarıldığı
        üçüncü kişilere bildirilmesini isteme, münhasıran otomatik sistemler ile analiz edilmesi suretiyle aleyhinize
        bir sonucun ortaya çıkmasına itiraz etme ve kanuna aykırı işleme nedeniyle zarara uğramanız hâlinde zararın
        giderilmesini talep etme haklarına sahipsiniz.</p>

    <h2>9. Başvuru yöntemi</h2>
    <p>Haklarınıza ilişkin taleplerinizi, KVKK ve Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ’e
        uygun olarak <a routerLink="/iletisim">İletişim</a> sayfasındaki kanallar üzerinden TV264’e iletebilirsiniz.
        Başvurular, kimliğinizi tespit etmeye elverişli bilgilerle yapılmalıdır. Talepler, niteliğine göre en geç
        30 gün içinde ücretsiz olarak sonuçlandırılır; işlemin ayrıca bir maliyet gerektirmesi hâlinde Kişisel
        Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilir.</p>

    <h2>10. Güncelleme</h2>
    <p>TV264, bu aydınlatma metnini mevzuat veya işleme faaliyetlerindeki değişikliklere göre güncelleyebilir.
        Güncel metin bu sayfada yayımlanır.</p>
</div>
